import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL;


export default class TransportService {
    getAlumnesFromLinia(id) {
        const options = {
            id
        };
        return axios.post(API_URL + "/gestransport/transport/linia/get-alumnes", options, { headers: authHeader() })
            .then(response => {
                return response.data;
            });
    }
    getAlumnesFrom(t,id,extra){
        const options = {
            t,id,extra
        };
        return axios.post(API_URL + "/gestransport/transport/get-alumnes-from", options, { headers: authHeader() })
            .then(response => {
                return response.data;
            });
    }
    getLiniesFrom(t,id,extra){
        const options = {
            t,id,extra
        };
        return axios.post(API_URL + "/gestransport/transport/get-linies-from", options, { headers: authHeader() })
            .then(response => {
                return response.data;
            });
    }


}
